"use client"

import { create } from "zustand"
import { useEffect } from "react"

const STORAGE_KEY = "glasswing_pinned_nav"

interface PinnedNavState {
  pinnedRoutes: string[]
  loadPinned: () => void
  togglePin: (route: string) => void
  clearAll: () => void
}

export const usePinnedNavStore = create<PinnedNavState>((set, get) => ({
  pinnedRoutes: [],
  loadPinned: () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      const routes = stored ? JSON.parse(stored) : []
      set({ pinnedRoutes: routes })
    } catch {
      set({ pinnedRoutes: [] })
    }
  },
  togglePin: (route: string) => {
    const current = get().pinnedRoutes
    const next = current.includes(route) ? current.filter((r) => r !== route) : [...current, route]
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    set({ pinnedRoutes: next })
  },
  clearAll: () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([]))
    set({ pinnedRoutes: [] })
  },
}))

export function PinnedNavSyncer() {
  const loadPinned = usePinnedNavStore((state) => state.loadPinned)

  useEffect(() => {
    loadPinned()
  }, [loadPinned])

  return null
}
